
  import { useStore } from 'vuex'

  import ContactBadge from '@/components/ContactBadge/index.vue'
  import ActionList from '@/components/ActionList/index.vue'
  import { computed, defineComponent, onBeforeMount, ref, watch } from 'vue'
  import moment from 'moment'
  import { CompanyModel } from '@/services/api/models1'
  import { MAINACTIONS, ActionListItem } from '@/types'
  import { useI18n } from 'vue-i18n'
  import { useRoute, useRouter } from 'vue-router'
  import { useAcl } from 'vue-simple-acl/src'
  import { ElTooltip } from 'element-plus'

  export default defineComponent({
    name: 'ContactCard',
    components: {
      ActionList,
      ContactBadge,
      ElTooltip
    },
    directives: {},
    props: {
      contact: {
        type: Object,
        required: true
      },
      noPadding: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    emits: ['delete-contact'],
    setup(props, { emit }) {
      const { t } = useI18n()
      const router = useRouter()
      const store = useStore()
      const route = useRoute()
      const url = ref('')
      const display = ref(false)
      const currentCompany = computed<CompanyModel>(
        () => store.getters['organizations/contextCompany']
      )
      const acl = useAcl()
      const canDelete = computed(
        () =>
          acl.role('admin') ||
          acl.permission('is-manager') ||
          acl.permission('write-contacts')
      )
      const actionsListItems = ref<ActionListItem[]>([
        {
          name: t('global.actions.edit'),
          action: 'edit',
          children: [],
          icon: '',
          key: MAINACTIONS.EDIT_CONTACT,
          type: ''
        }
      ])

      if (canDelete.value) {
        actionsListItems.value.push({
          name: t('global.actions.delete'),
          action: 'delete',
          children: [],
          icon: '',
          key: MAINACTIONS.DELETE_CONTACT,
          type: ''
        })
      }
      const openContactModal = () => {
        router.push({
          name: 'company.contact',
          params: {
            id: currentCompany.value?.id,
            contactId: route.params.contactId
          }
        })
      }
      const handleAction = (key: MAINACTIONS) => {
        if (key === MAINACTIONS.EDIT_CONTACT) {
          openContactModal()
        } else if (key === MAINACTIONS.DELETE_CONTACT) {
          deleteContact()
        }
      }

      const deleteContact = () => {
        emit('delete-contact', props.contact.id)
      }
      const loadImage = async () => {
        const response = await store.dispatch(
          'organizations/LOAD_CONTACT_PICTURE',
          {
            companyId: currentCompany.value.id,
            contactId: props.contact.id
          }
        )
        if (response) url.value = response
        else url.value = ''
      }
      watch(
        () => props.contact,
        async () => {
          await loadImage()
        }
      )
      onBeforeMount(async () => {
        await loadImage()
      })
      return {
        moment,
        url,
        display,
        currentCompany,
        actionsListItems,
        handleAction
      }
    }
  })
